import React from 'react'
import logo from "./logo.png"


function Cierre2() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-gray-800 font-sans">
      <header className="text-2xl mb-4">
        Tu pago no fue procesado exitosamente
      </header>
      <div className="text-lg text-center max-w-md mb-8">
        <p>
           Revisa tu información bancaria y vuelve a intentarlo. 
        </p>
        <p>
          ¡Te esperamos! 
        </p>
      </div>
      <img src={logo} className="w-1/3 rounded-full"></img>
      <footer className="text-sm mt-8">
        © 2024 DrawingsMachines - Todos los derechos reservados.
      </footer>
    </div>
  )
}

export default Cierre2